/**
 * Azure Application Insights setup: configures the SDK with the React plugin
 * and exposes helpers for resolving the environment and tracking events.
 * @exports reactPlugin, appInsights, trackEvent
 * @author {Cognizant Technology Solutions}
 */
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import appString from '../env.json';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: appString.APPINSIGHTS_CONNECTION_STRING,
    extensions: [reactPlugin],
    extensionConfig: {},
    enableAutoRouteTracking: false,
    disableAjaxTracking: true,
    autoTrackPageVisitTime: false,
    enableCorsCorrelation: false,
    enableRequestHeaderTracking: false,
    enableResponseHeaderTracking: false
  }
});
appInsights.loadAppInsights();

/**
 * Maps the configured API source to a telemetry environment label.
 * @returns {string} The environment name (e.g. DEV, RELQA, PROD)
 */
export const getCurrentEnv = () => {
  let currentEnv = 'DEV';
  if (['NONPROD7'].includes(appString.APISource)) {
    currentEnv = 'RELQA';
  } else if (['NONPROD6'].includes(appString.APISource)) {
    currentEnv = 'PSQA';
  } else if (['NONPROD8'].includes(appString.APISource)) {
    currentEnv = 'PSQASEA';
  } else if (['PROD'].includes(appString.APISource)) {
    currentEnv = 'PROD';
  }

  return currentEnv;
};

/**
 * Tracks a DPOM link-click event in Application Insights with page, user,
 * environment, and timestamp properties.
 * @param {string} pageId The clicked page/link identifier
 * @param {string} userEmail The current user's email
 * @returns {void}
 */
const trackEvent = (pageId, userEmail) => {
  const userId = userEmail;
  const timeStampId = new Date(Date.now()).toISOString();
  const env = getCurrentEnv();
  appInsights.trackEvent({
    name: 'clickDPOMLink',
    properties: {
      pageId, userId, env, timeStampId
    }
  });
};

export { reactPlugin, appInsights, trackEvent };
